import { createFileRoute } from '@tanstack/react-router';
import paragraphs from '@/content/terms.json';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  const contentsStart = paragraphs.indexOf('TABLE OF CONTENTS');
  const bodyStart = paragraphs.indexOf('1. OUR SERVICES');

  return (
    <article className="mx-auto max-w-3xl px-6 py-12 sm:py-16 break-words">
      {paragraphs.map((text, index) => {
        if (index === 0) {
          return <h1 key={index} className="text-3xl font-bold tracking-tight mb-4">{text}</h1>;
        }
        if (index > contentsStart && index < bodyStart) {
          const section = index - contentsStart;
          return (
            <a key={index} href={`#section-${section}`} className="block py-1 text-sm text-primary underline underline-offset-4">
              {section}. {text}
            </a>
          );
        }
        const section = text.match(/^(\d+)\. [A-Z]/)?.[1];
        if (section || index === 3 || index === contentsStart) {
          return (
            <h2 key={index} id={section ? `section-${section}` : undefined} className="scroll-mt-20 mt-10 mb-4 text-xl font-semibold">
              {text}
            </h2>
          );
        }
        return <p key={index} className="mb-4 text-sm sm:text-base leading-relaxed text-muted-foreground whitespace-pre-wrap">{text}</p>;
      })}
    </article>
  );
}
